import { render } from "./ArvoresImagesComponent.vue?vue&type=template&id=63bb96e4"
import script from "./ArvoresImagesComponent.vue?vue&type=script&lang=js"
export * from "./ArvoresImagesComponent.vue?vue&type=script&lang=js"

import "./ArvoresImagesComponent.vue?vue&type=style&index=0&id=63bb96e4&lang=css"

import exportComponent from "C:\\agilS\\agil.webgisprod\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__